import React, {useEffect} from "react";
import { AppDispatch } from "../../../redux/store";
import { useDispatch } from "react-redux";
import { fetchSpaUpgradeRequests } from "../../../redux/actions/upgradeRequests.actions";
import HistoryTable from "../../UpgradeRequests/components/HistoryTable";

interface ReportsTableProps {
    spa_guid: string;
    startDate: string;
    endDate: string;
}

// One spa's upgrade requests over the report's date range. Rendered inside the report's
// result card (SpaReport), which supplies the toolbar and the View All Requests button.
const ReportUpgradeHistory: React.FC<ReportsTableProps> = ({spa_guid, startDate, endDate}) => {
    const dispatch: AppDispatch = useDispatch();

    useEffect(() => {
        if(spa_guid) {
            dispatch(fetchSpaUpgradeRequests({spa_id:spa_guid, params:`from=${startDate}&until=${endDate}`}))
        }
    }, [dispatch, startDate,endDate, spa_guid]);

  return <HistoryTable page='reports'/>;
};

export default ReportUpgradeHistory;
